import { isEmpty } from 'lodash';
import moment from 'moment';

const getNotificationResponse = (response, previousResponse, page) => {
  const totalData = response?.totalData;
  const totalPage = response?.totalPage;

  let notifications = response?.notifications?.map((item) => {
    return {
      date: moment(item?.createdAt).format('DD'),
      month: moment(item?.createdAt).format('MMM'),
      title: item?.title ?? '-',
      time: moment(item?.createdAt).format('HH:mm'),
      description: item?.notificationMessage,
      targetUrl: item?.targetUrl,
      id: item?.id,
    };
  });

  if (!isEmpty(previousResponse) && page !== 1) notifications = [...previousResponse, ...notifications];

  return { notifications, totalData, totalPage };
};

export default getNotificationResponse;
